<script setup lang="ts">
import sidebarIcon from '@/assets/svg/sidebar.svg'

defineProps<{
  hasUnreadConversations?: boolean
}>()
</script>

<template>
  <div class="relative w-5 h-5">
    <img alt="Sidebar Icon" class="w-full h-full" :src="sidebarIcon" />
    <div v-if="hasUnreadConversations" class="absolute top-0 right-0 w-1.5 h-1.5 rounded-full bg-black"></div>
  </div>
</template>
